(function() {

  'use strict';
  var slider_galleria = $('.slider-galleria');
  
  slider_galleria.owlCarousel({
    // center:true,
    loop:false,
    interval: 2000,
    pause: "false",
    smartSpeed: 1000,
    items:3,
    dots: true,
    autoplay:false,
    autoplayTimeout:5000,
    autoplayHoverPause:false,
    nav: false,
    responsiveClass:true,
    responsive:{
      0:{
        stagePadding: 50,
        margin: 20,
        dots: false,
        items:1
      },
      576:{
        stagePadding: 50,
        margin: 20,
        dots: false,
        items:2
      },
      992:{
        stagePadding: 50,
        margin: 20,
        items:2
      },
      1200 : {
        stagePadding: 50,
        margin: 20,
        items: 3
      }
    }
  });

}());
